import { render, staticRenderFns } from "./MatchInfoResults.vue?vue&type=template&id=c6c1bf96&scoped=true"
import script from "./MatchInfoResults.vue?vue&type=script&lang=js"
export * from "./MatchInfoResults.vue?vue&type=script&lang=js"
import style0 from "./MatchInfoResults.vue?vue&type=style&index=0&id=c6c1bf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c1bf96",
  null
  
)

export default component.exports